export default {

    readPropStringOrDefault: function(el, name, defaultValue){
        let result = defaultValue ?? null;
        if(typeof(el.dataset[name])=='string' && el.dataset[name].length>0){
            result = el.dataset[name];
        }
        return result;
    },
    readPropObjOrDefault: function(el, name, defaultValue){
        let result = defaultValue ?? null;
        const stringValue = this.readPropStringOrDefault(el,name);
        if(stringValue){
            try{
                result = JSON.parse(stringValue);
            } catch(ex) {
                console.log(`VFP: failed to parse ${name} data prop`, ex);
            }
        }
        return result;
    }

}